import { SimpleGrid } from '@chakra-ui/react'

import { Span } from 'components'
import { Address } from 'modules/Geo/types'

type Props = {
  address: Address
}

export default function CustomFormAddressByCEP({ address }: Props) {
  if (!address.state) return null
  return (
    <SimpleGrid columns={[1, 1, 2, 2, 2, 2]} gap={1} mt={2}>
      <Span label="Rua: " value={address.street} />
      <Span label="Bairro: " value={address.neighborhood} />
      <Span label="Cidade: " value={address.city} />
      <Span label="Estado: " value={address.state} />
      <Span label="País: " value="Brasil" />
    </SimpleGrid>
  )
}
